// #####################################################################
// #                       MAIN CHECK INPUT JS FILE                    #
// #####################################################################
export function validateField(field, warningId) {
    try {
        let value = field.value;
        if (value == undefined) {
            value = field[1].trim();
        }
        const hasNumber = /\d/.test(value);
        const hasLetter = /[a-zA-Z]/.test(value);
        const validStreetFormat = /^[a-zA-ZäöüÄÖÜß\s]+ \d+[a-zA-Z]?$/;

        let warning = document.getElementById(warningId);

        if (!hasNumber || !hasLetter || !validStreetFormat.test(value)) {
            if (!warning) {
                warning = document.createElement("div");
                warning.id = warningId;
                warning.style.color = "#e52427";
                warning.innerHTML =
                    "Bitte füllen Sie dieses Feld aus und geben Sie eine Hausnummer sowie mindestens einen Buchstaben an.<br><b>Beispiele: Musterstraße 1, Mustersstraße 1a, Musterstraße 1/2/3</b>";

                if (field && field.parentNode) {
                    field.parentNode.appendChild(warning);
                } else {
                    // console.warn("Das Feld oder das übergeordnete Element fehlt.");
                    // Optional: Dynamisch ein Element hinzufügen
                    if (!field) {
                        // console.warn("Das Feld existiert nicht. Erstelle ein Dummy-Feld.");
                        // Ein Beispiel für das Erstellen eines Dummy-Feldes
                        let newField = document.createElement("input");
                        newField.id = "newField";
                        newField.type = "text";
                        newField.placeholder = "Dummy Feld";
                        document.body.appendChild(newField); // Füge es zum Body hinzu
                    }
                    if (!field.parentNode) {
                        let overviewAddress = document.getElementsByClassName(
                            "js-confirm-overview-addresses"
                        )[0]; // Erstes Element auswählen
                        if (overviewAddress) {
                            let container = document.createElement("div");
                            container.id = "newContainer";
                            container.appendChild(warning);
                            overviewAddress.appendChild(container); // Füge das neue Element zum ausgewählten Element hinzu
                        } else {
                            // console.warn("Kein Element mit der Klasse 'js-confirm-overview-addresses' gefunden.");
                        }
                    }
                }
            }
            // Button deaktivieren
            submitButton.disabled = true;
            submitButton.style.backgroundColor = "#666";
        } else {
            if (warning) {
                warning.remove();
            }
            // Button aktivieren
            if (allFieldsValid()) {
                submitButton.disabled = false;
                submitButton.style.backgroundColor = "#9cc43d";
            }
        }
    } catch (error) {
        // console.error("Ein Fehler ist aufgetreten:", error);
    }
}

export function clearWarning(warningId) {
    let warning = document.getElementById(warningId);
    if (warning) {
        warning.remove();
    }
}

export function checkInputFormStreetNumber() {
    // Holt das Eingabefeld "Straße und Hausnummer" mittels seiner ID.
    const streetField = document.getElementById("billingAddressAddressStreet");
    const shippingStreetField = document.getElementById("shippingAddressAddressStreet");
    const confirmAdress = document.getElementsByClassName("address");
    const shippingAddressToggle = document.querySelector(".js-form-field-toggle-shipping-address");
    // Holt den spezifischen Button mittels des umgebenden div und der Klasse
    const submitButton = document.querySelector(".register-submit .btn.btn-primary.btn-lg");
    // Initiale Überprüfung, falls das Feld bereits beim Laden der Seite gefüllt ist
    if (streetField) {
        validateStreetField();
        validateShippingStreetField();
    } else {
        // console.log("INITIAL STREETFIELD CHECK FAILED... Field does not exist");
    }

    streetField.addEventListener("input", validateStreetField);
    shippingStreetField.addEventListener("input", validateShippingStreetField);

    function validateStreetField() {
        validateField(streetField, "streetWarning");
    }

    function validateShippingStreetField() {
        if (window.getComputedStyle(shippingAddressToggle).display !== "none") {
            validateField(shippingStreetField, "shippingStreetWarning");
        } else {
            clearWarning("shippingStreetWarning");
        }
    }

    function allFieldsValid() {
        const billingValid = /\d/.test(streetField.value) && /[a-zA-Z]/.test(streetField.value);
        let shippingValid = true; // Default to true if shipping address toggle is hidden

        if (window.getComputedStyle(shippingAddressToggle).display !== "none") {
            shippingValid =
                /\d/.test(shippingStreetField.value) && /[a-zA-Z]/.test(shippingStreetField.value);
        }

        return billingValid && shippingValid;
    }
}

export function checkPhoneNumberInputField() {
    const phoneField = document.getElementById("billingAddressAddressPhoneNumber");
    phoneField.addEventListener("input", validatePhoneNumber);

    function validatePhoneNumber() {
        const value = phoneField.value.trim();
        const phonePattern = /^(\+49|0049|\+41|0041|\+43|0043)[1-9]\d{1,14}$/; // Regex für Telefonnummer mit Ländervorwahl
        let warning = document.getElementById("phoneWarning");

        const isValid = phonePattern.test(value);

        if (!isValid) {
            if (!warning) {
                warning = document.createElement("div");
                warning.id = "phoneWarning";
                warning.style.color = "#e52427";
                // warning.style.animation = "blink 1s step-end infinite";
                warning.textContent =
                    "Bitte geben Sie eine gültige Telefonnummer mit korrekter Ländervorwahl für Deutschland (+49), Schweiz (+41) oder Österreich (+43) ein.";
                phoneField.parentNode.appendChild(warning);
            }
        } else {
            if (warning) {
                warning.remove();
            }
        }
    }
}

export function checkAddressContent() {
    const addressElement = document.querySelector(".address");
    const submitButton = document.getElementById("confirmOrderForm");

    if (addressElement) {
        const addressContent = addressElement.innerText.toLowerCase();

        if (addressContent.includes("custom") || addressContent.includes("default")) {
            alert("Bitte passen Sie ihre Lieferaddresse an...");
            submitButton.remove();
        } else {
            // console.log("Weder 'custom' noch 'default' wurden gefunden.");
            if (!submitButton) {
                submitButton.add();
            }
        }
    }
}

export function validateAddressStreetField() {
    const addressElement = document.querySelector(".address");
    const submitButton = document.getElementById("confirmOrderForm");

    if (addressElement) {
        const addressContent = addressElement.innerText
            ? addressElement.innerText.toLowerCase().split("\n")
            : null; // Prüfen, ob innerText vorhanden ist
        if (addressContent && addressContent[1]) {
            const secondLine = addressContent[1].trim();
            const thirdLine = addressContent[2].trim();
            // const houseNumberPattern = /^[a-zA-ZäöüÄÖÜß\s\-\.\/\\]+[.,]?(\s[a-zA-Z])?\s\d+(\s?[a-zA-Z])?(\/\d+[a-zA-Z]?)*$/;
            const houseNumberPattern = /^[a-zA-ZäöüÄÖÜßÀ-ÿ0-9\s\-\.',\/\\]+(?:\sLot\s\d+)?(?:\s\d+[a-zA-Z]?)?(?:\/\d+[a-zA-Z]?)?$/;


            if (houseNumberPattern.test(secondLine) || houseNumberPattern.test(thirdLine)) {
                if (!submitButton) {
                    submitButton.add();
                }
            } else {
                validateField(addressContent, "streetWarning");
                if (submitButton) {
                    submitButton.remove();
                }
            }
        } else {
            // console.log("Die Adresse enthält keine zweite Zeile.");
        }
    } else {
        alert("Das Element mit der Klasse 'address' wurde nicht gefunden.");
    }
}

export function initializeDropzone(dropzoneId = 'dropzone', inputId = 'bewerbungsunterlagen') {
    const dropzone = document.getElementById(dropzoneId);
    const fileInput = document.getElementById(inputId);

    dropzone.addEventListener('click', () => fileInput.click());
    dropzone.addEventListener('dragover', (e) => {
        e.preventDefault();
        dropzone.classList.add('dropzone--over');
    });
    dropzone.addEventListener('dragleave', () => dropzone.classList.remove('dropzone--over'));
    dropzone.addEventListener('drop', (e) => {
        e.preventDefault();
        dropzone.classList.remove('dropzone--over');
        if (e.dataTransfer.files) {
            fileInput.files = e.dataTransfer.files;
        }
    });
}

// ####################################################################
// #                      CHECK export functionS CALL                        #
// ####################################################################
export function checkInputs() {
    checkInputFormStreetNumber();
    checkPhoneNumberInputField();
    checkAddressContent();
}